import { render, staticRenderFns } from "./BasicCard-v2.vue?vue&type=template&id=06b0fe95"
import script from "./BasicCard-v2.vue?vue&type=script&lang=js"
export * from "./BasicCard-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports